import { Component } from "@angular/core";

import { MatDialogModule } from "@angular/material/dialog";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
	selector: "ic-new-app-version-dialog",
	imports: [MatDialogModule, TranslatePipe],
	templateUrl: "./new-app-version-dialog.component.html",
	styleUrls: ["./new-app-version-dialog.component.scss"],
})
export class NewAppVersionDialogComponent {}
